import { initialize } from 'modules/errorSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useErrorPage = () => {
  const dispatch = useDispatch();

  const { error, loading } = useSelector(({ error }) => error);

  useEffect(() => {
    return () => {
      dispatch(initialize());
    };
  }, [dispatch]);

  return { error, loading };
};

export default useErrorPage;
